/**
 * Canonical ordering and display labels for send-insight dimensions.
 *
 * Mirrors the Python definition in
 * decision_engine/decision_engine/policy/scheduling/time_utils.py
 * (TIME_BUCKET_TO_TIME).
 *
 * Shared by frontend (grid-chart sorting / label resolution) and backend
 * (SQL generation).  Keep this file free of Node-only or browser-only imports
 * so it stays importable from both sides.
 */

/** Map from time-bucket key → start hour of the 3-hour window. */
export const TIME_BUCKET_START_HOUR: Record<string, number> = {
  midnight: 0,
  late_night: 3,
  early_morning: 6,
  morning: 9,
  afternoon: 12,
  mid_afternoon: 15,
  evening: 18,
  night: 21,
};

/** Human-readable labels for each time-bucket key. */
export const TIME_BUCKET_LABELS: Record<string, string> = {
  early_morning: "Early morning",
  morning: "Morning",
  afternoon: "Afternoon",
  mid_afternoon: "Mid afternoon",
  evening: "Evening",
  night: "Night",
  late_night: "Late night",
  midnight: "Midnight",
};

/** Chronological order of time-bucket keys. */
export const TIME_BUCKET_ORDER = [
  "midnight",
  "late_night",
  "early_morning",
  "morning",
  "afternoon",
  "mid_afternoon",
  "evening",
  "night",
] as const;

/** Chronological order of day-of-week display names (Sunday-first). */
export const DAY_OF_WEEK_ORDER = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
] as const;
